import { MicIcon } from 'lucide-react';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@nesso/ui/primitives/select';

import { AudioLevelMeter, useMicStore } from '@/entities/audio-recording';

export function SelectMic() {
    const currentMicId = useMicStore((x) => x.currentMicId);
    const mics = useMicStore((x) => x.mics);
    const selectMic = useMicStore((x) => x.selectMic);
    const micStream = useMicStore((x) => x.currentStream);

    return (
        <div className="flex items-center gap-2 w-full">
            <Select value={currentMicId || ''} onValueChange={selectMic} disabled={!micStream}>
                <SelectTrigger className="relative flex items-center justify-between w-full px-3 py-2">
                    <div className="flex items-center gap-2 flex-1 min-w-0 max-w-[190px]">
                        <MicIcon className="size-4 flex-shrink-0 text-muted-foreground" />
                        <div className="truncate ">
                            <SelectValue placeholder="Select microphone" />
                        </div>
                    </div>
                    <AudioLevelMeter audioStream={micStream} />
                </SelectTrigger>
                <SelectContent className="w-[var(--radix-select-trigger-width)]">
                    {mics?.map((mic) => (
                        <SelectItem key={mic.deviceId} value={mic.deviceId}>
                            {mic.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
